// extracted by mini-css-extract-plugin
export default {"eligibility":"lq-z"};